import { environment } from './environments/env';

class EnvironmentProvider {
  private readonly currentEnvironment = environment;

  getEnvironment() {
    return this.currentEnvironment;
  }

  getServiceApiBaseUrls() {
    return this.currentEnvironment.serviceApiBaseUrls;
  }

  getCloudProviderBaseUrls(cloudProvider: 'AWS' | 'Azure' = 'AWS') {
    return cloudProvider === 'AWS'
      ? this.currentEnvironment.serviceApiBaseUrls.cloudProviderApiBaseUrls.AWS
      : this.currentEnvironment.serviceApiBaseUrls.cloudProviderApiBaseUrls
          .Azure;
  }
}

export const environmentProvider = new EnvironmentProvider();
